/* eslint-disable react/jsx-pascal-case */
import { memo, useEffect, useRef } from 'react'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography'
import { HtmlToolTip } from 'assets/ToolTips'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { baseStyle } from 'assets/TableHeader'
import { fixNullString } from 'utils/stringUtil'

type Props = {
  caption?: boolean
  title?: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
  data?: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
  width?: number | string
  change?: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined
  disabled?: boolean
  focus?: boolean
  left?: number
  color?: string
}

const useStyles = makeStyles(() =>
  createStyles({
    hidden: {
      backgroundColor: 'inherit',
    },
    fixed: (props: { left?: number }) => ({
      position: 'sticky',
      backgroundColor: 'inherit',
      left: props.left,
      zIndex: 1,
    }),
  }),
)

// const tooltipDelay = 1000 // ツールチップが表示されるまでの長押し時間
const max = 100

/**
 * 幅をpx指定する場合はこちら
 * @param param0
 * @returns
 */
const A_TableCellForm = ({ caption = true, title, data, width = 30, change = () => {}, disabled = false, focus = false, left = undefined, color = 'none' }: Props) => {
  useEffect(() => {
    if (focus) {
      ref.current?.focus()
    }
  }, [focus])

  const classes = useStyles({ left: left })
  const ref = useRef<HTMLInputElement>(null)

  const style = { ...baseStyle, minWidth: width, backgroundColor: color }
  const leftClass = left != null ? classes.fixed : undefined

  return (
    <TableCell style={style} className={leftClass} padding="checkbox" align="left">
      {caption ? (
        <HtmlToolTip
          title={
            <Typography variant="caption" color="inherit">
              {title}
            </Typography>
          }
          enterTouchDelay={1500}
          leaveTouchDelay={10000}
          interactive={true}
          classes={title ? {} : { tooltip: classes.hidden }}
        >
          <input type={'text'} value={`${fixNullString(data as any)}`} maxLength={max} style={{ width: '100%' }} disabled={disabled} onChange={change} />
        </HtmlToolTip>
      ) : (
        <input type={'text'} value={`${fixNullString(data as any)}`} maxLength={max} style={{ width: '100%' }} disabled={disabled} onChange={change} />
      )}
    </TableCell>
  )
}

export default memo(A_TableCellForm)
